import React from 'react';
import { connect } from 'react-redux';

import { entitySelectors } from '@store/entity/selectors';
import { NormalizedStore } from '@store/entity/entity.types';

import { ProductsV2 } from './ProductsV2';
import { ProductsV2OwnProps, ProductsV2StoreProps } from './ProductsV2.types';

const mapStateToProps = (
  state: NormalizedStore,
  ownProps: ProductsV2OwnProps
): ProductsV2StoreProps => ({
  property: entitySelectors.getProperty(
    state,
    Array.isArray(ownProps.id) ? ownProps.id[0] : ownProps.id
  ),
  products: entitySelectors.getAllProducts(state),
});

export const ProductsV2Connected: React.ComponentType<ProductsV2OwnProps> =
  connect(mapStateToProps)(ProductsV2);
